import React, { useState } from "react";
import {
  View,
  Text,
  TextInput,
  TouchableOpacity,
  StyleSheet,
  Switch,
  ScrollView,
  Alert,
} from "react-native";
import { observer } from "mobx-react";
import { extraStore } from "../stores/ExtraStore";
import { IContent } from "@interfaces/icontent";
import { goBack } from "../services/NavigationService";
import { Theme } from "../enum/Theme";
import PhotoUploader from "./PhotoUploader";
import { RouteProp, useRoute } from "@react-navigation/native";
import { EnumRoutesAppWeb } from "../enum/EnumRoutesAppWeb";
import RichTextEditor from "./RichTextEditor";
import { Language } from "@constants/language";
import { LanguageSelector } from "../comps/LanguageSelector";

type ExtraFormRouteProp = RouteProp<
  { [EnumRoutesAppWeb.createEditExtra]: { extra?: IContent } },
  EnumRoutesAppWeb.createEditExtra
>;

const ExtraForm = observer(() => {
  const route = useRoute<ExtraFormRouteProp>();
  const extra = route.params?.extra;

  const [title, setTitle] = useState(extra?.title || "");
  const [resume, setResume] = useState(extra?.resume || "");
  const [description, setDescription] = useState(extra?.description || "");
  const [lang, setLang] = useState<Language>(extra?.lang || "pt");
  const [active, setActive] = useState(extra?.active ?? true);
  const [medias, setMedias] = useState(extra?.medias || []);

  const isFormValid = () => !!title.trim();

  const handleSave = async () => {
    if (!isFormValid()) {
      Alert.alert("Atenção", "Preencha o título.");
      return;
    }

    const extraToSave: Omit<IContent, "id"> = {
      title,
      resume,
      description,
      lang,
      active,
      medias,
      type: "extra",
    };

    await extraStore.saveExtra(extraToSave, extra?.id);
    goBack();
  };

  return (
    <ScrollView style={styles.container}>
      <Text style={styles.title}>{extra ? "Editar Extra" : "Novo Extra"}</Text>



      <Text style={styles.section}>Título:</Text>
      <TextInput
        placeholder="Digite o título"
        value={title}
        onChangeText={setTitle}
        style={styles.input}
      />

      <LanguageSelector value={lang} onChange={setLang} />

      <Text style={styles.section}>Resumo:</Text>
      <TextInput
        placeholder="Digite o resumo"
        value={resume}
        onChangeText={setResume}
        style={styles.input}
      />

      <Text style={styles.section}>Descrição:</Text>
      <RichTextEditor
        initialContent={description}
        onChange={setDescription}
      />

      <Text style={styles.section}>Foto:</Text>
      <PhotoUploader
        postId={extra?.id || "tempExtra"}
        media={medias}
        setMedia={setMedias}
        mainMediaUrl={medias?.[0]?.url || ""}
        setMainMediaUrl={() => { }}
      />

      <View style={styles.switchContainer}>
        <Text>Ativo:</Text>
        <Switch value={active} onValueChange={setActive} />
      </View>

      <TouchableOpacity
        style={[
          styles.saveButton,
          { backgroundColor: isFormValid() ? Theme.foreground : "#ccc" },
        ]}
        onPress={handleSave}
        disabled={!isFormValid()}
      >
        <Text style={styles.saveButtonText}>Salvar</Text>
      </TouchableOpacity>
    </ScrollView>
  );
});

export default ExtraForm;

const styles = StyleSheet.create({
  container: { flex: 1, padding: 20, backgroundColor: "#F2F2F2" },
  title: { fontSize: 22, fontWeight: "bold", marginBottom: 20 },
  section: { marginTop: 15, fontWeight: "bold" },
  input: {
    borderWidth: 1,
    borderColor: "#ccc",
    borderRadius: 5,
    padding: 10,
    marginBottom: 10,
  },
  switchContainer: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: 10,
  },
  saveButton: {
    padding: 15,
    borderRadius: 5,
    marginTop: 20,
  },
  saveButtonText: {
    color: "#fff",
    textAlign: "center",
    fontWeight: "bold",
  },
});
